import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import { productCollection } from 'app/src/msw/companyagreement/initialSeed/products'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const postToggleFavourite = http.post<
  object,
  companyagreementApi.FavouriteToggleRequest,
  companyagreementApi.FavouriteToggleResponse | object
>(apiBaseUrl + '/favourites/toggle', async ({ request }) => {
  const { productId } = await request.json()
  console.log('Received request for postToggleFavourite with params:', { productId })
  const updatedProduct = await productCollection.update((p) => p.where({ productId: productId }), {
    data(product) {
      product.isFavourite = !product.isFavourite
    },
  })

  if (updatedProduct) {
    const response = {
      isFavourite: updatedProduct.isFavourite,
    }
    return HttpResponse.json(response, { status: 200 })
  } else {
    return HttpResponse.json({}, { status: 500 })
  }
})
